import { render } from "./harvesterhci.io.volume.vue?vue&type=template&id=0600c7c4&scoped=true"
import script from "./harvesterhci.io.volume.vue?vue&type=script&lang=js"
export * from "./harvesterhci.io.volume.vue?vue&type=script&lang=js"

import "./harvesterhci.io.volume.vue?vue&type=style&index=0&id=0600c7c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0600c7c4"]])

export default __exports__